import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import FourCards from "../../Cards/FourCards/FourCards";

// images
import claimsIcon from "../../../images/forInsurer/claims-icn2.png";
import costIcon from "../../../images/forInsurer/cost-icn2.png";
import memberIcon from "../../../images/forInsurer/member-icn2.png";
import futureIcon from "../../../images/forInsurer/future-icn.png";

// styles
import * as styles from "./PartnerTrust.module.css";

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  sectionTitle: PropTypes.string,
  bottomText: PropTypes.string,
};

const defaultProps = {
  title: "Why Insurance Partners Trust Twin Health India",
  subtitle: "Transform Health, Not Just Cover It.",
  sectionTitle: "What you gain",
  bottomText:
    "Together, we build a value-based health model where better health equals better business outcomes.",
};

const PartnerTrust = ({ title, subtitle, sectionTitle, bottomText }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const cards = [
    {
      icon: claimsIcon,
      title: "Fewer claims",
      description: "70%+ members achieve remission or reversal.",
      iconAlt: "Fewer claims icon",
    },
    {
      icon: costIcon,
      title: "Lower costs",
      description: "1.5 Lakhs annual savings per member.",
      iconAlt: "Lower costs icon",
    },
    {
      icon: memberIcon,
      title: "Happier members",
      description: "Higher satisfaction and renewal rates.",
      iconAlt: "Happier members icon",
    },
    {
      icon: futureIcon,
      title: "Future-ready",
      description: "In-collab with IRDAI’s digital and preventive care.",
      iconAlt: "Future-ready icon",
    },
  ];

  return (
    <section className={`${styles.partnerTrustWrapper}`}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        {/* Section Title */}
        <div className={styles.sectionTitleWrapper}>
          <h3 className={styles.sectionTitle}>{sectionTitle}</h3>
        </div>

        {/* Cards Section */}
        <div className={styles.cardsSection}>
          <FourCards cards={cards} variant="default" />
        </div>

        {/* Bottom Text */}
        <div className={styles.bottomTextWrapper}>
          <p className={styles.bottomText}>{bottomText}</p>
        </div>
      </div>
    </section>
  );
};

PartnerTrust.propTypes = propTypes;
PartnerTrust.defaultProps = defaultProps;

export default PartnerTrust;
